// extracted by mini-css-extract-plugin
module.exports = {"root-container":"styles_root-container__1WRhn","grid-container":"styles_grid-container__hMg5H","deny-button":"styles_deny-button__9Oabe"};